export default (function (_ref) {
  var request = _ref.request;
  return {
    sourceUniqueDetailAdd: function sourceUniqueDetailAdd(data) {
      return request({
        url: '/source/uniqueDetail/add',
        method: 'post',
        data: data
      });
    },
    sourceUniqueDetailCancel: function sourceUniqueDetailCancel(id) {
      return request({
        url: "/source/uniqueDetail/".concat(id, "/cancel"),
        method: 'put'
      });
    },
    sourceUniqueDetailUse: function sourceUniqueDetailUse(id) {
      return request({
        url: "/source/uniqueDetail/".concat(id, "/use"),
        method: 'put'
      });
    },
    sourceUniqueDetailDel: function sourceUniqueDetailDel(id) {
      return request({
        url: "/source/uniqueDetail/".concat(id, "/del"),
        method: 'delete'
      });
    },
    sourceUniqueDetailBatchDel: function sourceUniqueDetailBatchDel(data) {
      return request({
        url: "/source/uniqueDetail/dels",
        method: 'delete',
        data: data
      });
    },
    sourceUniqueDetailBatchUse: function sourceUniqueDetailBatchUse(data) {
      return request({
        url: "/source/uniqueDetail/uses",
        method: 'put',
        data: data
      });
    },
    sourceUniqueDetailBatchCancel: function sourceUniqueDetailBatchCancel(data) {
      return request({
        url: "/source/uniqueDetail/cancels",
        method: 'put',
        data: data
      });
    },
    sourceUniqueDetailQuery: function sourceUniqueDetailQuery(data) {
      return request({
        url: '/source/uniqueDetail/query',
        method: 'get',
        params: data
      });
    },
    sourceUniqueDetailDetail: function sourceUniqueDetailDetail(id) {
      return request({
        url: "/source/uniqueDetail/".concat(id, "/detail"),
        method: 'get'
      });
    },
    sourceUniqueDetailStat: function sourceUniqueDetailStat() {
      return request({
        url: "/source/uniqueDetail/stat",
        method: 'get'
      });
    }
  };
});